<div class="register-container">
    <div class="register-card">
        @if(!successMessage){
        <div class="register-header">
            <h1>Créez votre compte</h1>
            <h3>Créez votre espace client et profitez d’un service de sécurité professionnel.</h3>
        </div>

        <form class="register-form" *ngIf="registerForm" [formGroup]="registerForm" (ngSubmit)="onSubmit()" novalidate>

            <div class="form-step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
                <div class="form-section">
                    <div class="form-row">
                        <div class="form-group name-group">
                            <input type="text" id="firstName" formControlName="firstName" [class.error]="hasError('firstName')" placeholder="Entrez votre prénom"> @if(hasError('firstName')) {
                            <div class="form_error">
                                {{ getFieldError('firstName') }}
                            </div>
                            }
                        </div>

                        <div class="form-group name-group">
                            <input type="text" id="lastName" formControlName="lastName" [class.error]="hasError('lastName')" placeholder="Entrez votre nom">
                            <div *ngIf="hasError('lastName')" class="form_error">
                                {{ getFieldError('lastName') }}
                            </div>
                        </div>
                    </div>

                    <div class="form-group email-group">
                        <input type="text" id="email" formControlName="email" [class.error]="hasError('email')" placeholder="Choisissez un email">
                        <div *ngIf="hasError('email')" class="form_error">
                            {{ getFieldError('email') }}
                        </div>
                        <div *ngIf="hasError('username')" class="form_error">
                            {{ getFieldError('username') }}
                        </div>
                    </div>

                    <div class="form-group phone-group">
                        <input type="tel" id="phoneNumber" formControlName="phoneNumber" [class.error]="hasError('phoneNumber')" placeholder="Entrez votre numéro de téléphone">
                        <div *ngIf="hasError('phoneNumber')" class="form_error">
                            {{ getFieldError('phoneNumber') }}
                        </div>
                    </div>

                    <!-- Address Section -->
                    <div class="form-row">
                        <div class="form-group streetn-group" formGroupName="address">
                            <input type="text" id="streetNumber" formControlName="streetNumber" placeholder="Numéro de rue">
                        </div>

                        <div class="form-group street-group" formGroupName="address">
                            <input type="text" id="street" formControlName="street" placeholder="Nom de la rue">
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group zip-group" formGroupName="address">
                            <input type="text" id="postalCode" formControlName="postalCode" placeholder="Code postal">
                        </div>
                        <div class="form-group city-group" formGroupName="address">
                            <input type="text" id="city" formControlName="city" placeholder="Ville">
                        </div>
                    </div>

                    <div class="form-row">
                        <!-- Company -->
                        <div class="form-group company-group">
                            <input type="text" id="company" formControlName="company" [class.error]="hasError('company')" placeholder="Société"> @if(hasError('company')) {
                            <div class="form_error">
                                {{ getFieldError('company') }}
                            </div>
                            }
                        </div>
                    </div>

                    <div class="form-row">
                        <!-- VAT Number -->
                        <div class="form-group vatNumber-group">
                            <input type="text" id="vatNumber" formControlName="vatNumber" [class.error]="hasError('vatNumber')" placeholder="N° TVA">
                            <div *ngIf="hasError('vatNumber')" class="form_error">
                                {{ getFieldError('vatNumber') }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Step 1 Navigation -->
                <div class="step-navigation">
                    <button type="button" class="next-step-btn" (click)="goToNextStep()" [disabled]="!isStep1Valid()">
                        <span>Confirmer</span>
                        <img src="assets/images/icons/arrow-right.png" alt="Next" class="arrow-icon">
                    </button>
                </div>
            </div>

            <!-- Step 2: Password -->
            <div class="form-step" [class.active]="currentStep === 2">
                <!-- Password Section -->
                <div class="form-section">
                    <div class="form-row">
                        <div class="form-group">
                            <div class="input-group password-group">
                                <img src="assets/images/icons/lock-red.png" alt="lock-icon" class="input-icon">
                                <input [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password" [class.error]="hasError('password')" placeholder="Créez un mot de passe">
                                <button type="button" class="password-toggle" (click)="togglePassword('password')">
                                    <img src="assets/images/icons/eye.png" alt="eye-icon">
                                </button>
                            </div>
                            <div *ngIf="hasError('password')" class="form_error">
                                {{ getFieldError('password') }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-section">
                    <div class="form-row">
                        <div class="form-group confirmPassword-group">
                            <div class="input-group">
                                <img src="assets/images/icons/lock-red.png" alt="lock-icon" class="input-icon">
                                <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword" formControlName="confirmPassword" [class.error]="hasError('confirmPassword')" placeholder="Confirmez votre mot de passe">
                                <button type="button" class="password-toggle" (click)="togglePassword('confirmPassword')">
                                    <img src="assets/images/icons/eye.png" alt="eye-icon">
                                </button>
                            </div>
                            <div *ngIf="hasError('confirmPassword')" class="form_error">
                                {{ getFieldError('confirmPassword') }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Step 2 Navigation -->
                <div class="step-navigation">
                    <button type="button" class="back-step-btn" (click)="goToPreviousStep()">
                        <img src="assets/images/icons/arrow-left.png" alt="Back" class="arrow-icon">
                        <span>Informations personnelles</span>
                    </button>
                    <button type="submit" class="register-btn" [disabled]="isLoading || registerForm.invalid" [class.loading]="isLoading">
                        <span *ngIf="!isLoading">Confirmer</span>
                        <span *ngIf="isLoading">Création en cours...</span>
                    </button>
                </div>
            </div>
        </form>
        }

        <!-- Messages -->
        @if(errorMessage){
        <div class="alert alert-error mt-3">
            <p class="form_error">{{ errorMessage }}</p>
        </div>
        } @if(successMessage){
        <div class="alert-card-success">
            <h3 class="alert-title"><em class="fa fa-check"></em> Inscription Réussie!</h3>
            <p class="alert-text">{{ successMessage }}</p>
            <p class="alert-text verification-help">
                Vous n'avez pas reçu l'email?
            </p>
            <button type="button" class="link-button" (click)="resendVerification()">
                Renvoyer le lien de vérification
            </button>
        </div>
        }

    </div>

    <div class="image-col">
        <img src="assets/images/call-man.svg" alt="Security Call Center" class="login-image">
    </div>
</div>